module.exports = __webpack_public_path__ + "media/application/images/svgs/skip-back-57c1b88e5f184f6bec3639ac777422d5.svg";